export const printContent = (title: string, htmlContent: string) => {
  const printWindow = window.open('', '_blank', 'width=800,height=900');
  if (!printWindow) {
    alert('الرجاء السماح للنوافذ المنبثقة للتمكن من الطباعة');
    return;
  }

  // Get all styles from the current document
  const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
    .map(style => style.outerHTML)
    .join('\n');

  printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${title}</title>
        ${styles}
        <style>
          @page { size: auto; margin: 0; }
          body { 
            background: white !important; 
            padding: 15mm !important; 
            margin: 0; 
            font-family: 'Inter', sans-serif;
          }
          .no-print { display: none !important; }
          .print-page-break { page-break-after: always; break-after: page; }
          @media print {
            .bg-slate-50 { background-color: rgb(248 250 252) !important; -webkit-print-color-adjust: exact; }
            .bg-slate-100 { background-color: rgb(241 245 249) !important; -webkit-print-color-adjust: exact; }
            .border-slate-200 { border-color: rgb(226 232 240) !important; }
            .text-slate-600 { color: rgb(71 85 105) !important; }
            .text-slate-900 { color: rgb(15 23 42) !important; }
          }
        </style>
      </head>
      <body>
        <div class="p-8">
          ${htmlContent}
        </div>
        <script>
          window.onload = () => {
            setTimeout(() => {
              window.print();
              // window.close(); // Optional: close after print
            }, 500);
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};
